(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["op-espace-professionnels"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('op-professional')) {
  customElements.define('op-professional', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const gate = this.querySelector('[data-gate]');
      const prices = this.querySelector('[data-prices]');
      const input = this.querySelector('[data-code]');
      const error = this.querySelector('[data-error]');
      const cartons = this.querySelector('[data-cartons]');
      const quoteCartons = this.querySelector('[data-quote-cartons]');
      const minus = this.querySelector('[data-minus]');
      const plus = this.querySelector('[data-plus]');
      const transfer = this.querySelector('[data-transfer]');
      const summary = this.querySelector('[data-quote-summary]');
      const calcError = this.querySelector('[data-calc-error]');
      const size = Number(this.dataset.cartonSize);
      const cents = Number(this.dataset.unitCents);
      const money = new Intl.NumberFormat('fr-FR', {style:'currency',currency:'EUR'});
      const requestType = this.querySelector('[data-request-type]');
      const associationPairs = this.querySelector('[data-association-pairs]');
      const isProfessional = () => requestType.value === 'professional';
      let count = 1;
      const valid = value => /^\d+$/.test(String(value)) && Number(value) >= 1 && Number(value) <= 999;
      const sync = () => {
        const pairs = count * size;
        const total = money.format(pairs * cents / 100);
        this.querySelector('[data-total-pairs]').textContent = String(pairs);
        this.querySelector('[data-total-price]').textContent = total;
        this.querySelector('[data-quote-pairs]').value = isProfessional() ? String(pairs) : associationPairs.value;
        this.querySelector('[data-quote-estimate]').value = !isProfessional() ? 'Offre association / groupe : tarif à établir sur devis' : prices.hidden ? 'Non demandée - tarifs non affichés' : total + ' TTC hors transport';
        summary.hidden = prices.hidden || !isProfessional();
        summary.textContent = count + (count > 1 ? ' cartons' : ' carton') + ' · ' + pairs + ' paires · ' + total + ' TTC hors transport';
        minus.disabled = count <= 1;
        plus.disabled = count >= 999;
      };
      const setCount = value => {
        if (!valid(value)) {
          calcError.textContent = 'Saisissez un nombre entier de cartons entre 1 et 999.';
          cartons.setAttribute('aria-invalid','true');
          return false;
        }
        count = Number(value);
        cartons.value = String(count);
        quoteCartons.value = String(count);
        calcError.textContent = '';
        cartons.removeAttribute('aria-invalid');
        sync();
        return true;
      };
      const listen = (element, event, handler) => element.addEventListener(event, handler, {signal:this.controller.signal});
      const updateRequest = () => {
        const pro = isProfessional();
        this.querySelector('[data-contact-heading]').textContent = pro ? 'Demander un devis professionnel' : requestType.value === 'group' ? 'Demander un devis pour un achat groupé' : 'Demander un devis association';
        if (!pro) {
          prices.hidden = true;
          gate.hidden = false;
          input.value = '';
          error.textContent = '';
          input.removeAttribute('aria-invalid');
        }
        this.querySelector('[data-cartons-field]').hidden = !pro;
        quoteCartons.disabled = !pro;
        quoteCartons.required = pro;
        this.querySelector('[data-association-field]').hidden = pro;
        associationPairs.disabled = pro;
        associationPairs.required = !pro;
        this.querySelector('[data-quote-packaging]').value = pro ? size + ' paires par carton' : 'Quantité spécifique à étudier sur devis';
        this.querySelector('[data-quote-subject]').value = pro ? 'Demande professionnelle - Jumelles 10x25' : requestType.value === 'group' ? 'Achat groupé - Jumelles 10x25' : 'Demande association - Jumelles 10x25';
        sync();
      };
      listen(requestType, 'change', updateRequest);
      const associationCardCount = this.querySelector('[data-association-card-count]');
      listen(associationPairs, 'input', () => {
        if (associationPairs.validity.valid) associationCardCount.value = associationPairs.value;
        sync();
      });
      listen(this.querySelector('[data-association]'), 'click', event => {
        if (!associationCardCount.reportValidity()) { event.preventDefault(); return; }
        associationPairs.value = associationCardCount.value;
        requestType.value = 'association';
        this.querySelector('[data-activity]').value = 'Association / collectivité';
        updateRequest();
      });
      listen(cartons, 'input', () => setCount(cartons.value));
      listen(cartons, 'change', () => { if (!setCount(cartons.value)) setCount(count); });
      listen(quoteCartons, 'input', () => { if (valid(quoteCartons.value)) setCount(quoteCartons.value); });
      listen(quoteCartons, 'change', () => { if (!valid(quoteCartons.value)) setCount(count); });
      listen(minus, 'click', () => setCount(Math.max(1, count - 1)));
      listen(plus, 'click', () => setCount(Math.min(999, count + 1)));
      listen(transfer, 'click', event => {
        requestType.value = 'professional';
        updateRequest();
        if (!setCount(cartons.value)) { event.preventDefault(); cartons.focus(); return; }
        const target = this.querySelector('.op-pro__contact');
        event.preventDefault();
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        target.scrollIntoView({behavior:reduce ? 'instant' : 'smooth',block:'start'});
        quoteCartons.focus({preventScroll:true});
      });
      updateRequest();
      this.querySelector('[data-unlock-form]').addEventListener('submit', (event) => {
        event.preventDefault();
        if (this.dataset.accessCode && input.value.trim() === this.dataset.accessCode) {
          requestType.value = 'professional';
          updateRequest();
          error.textContent = '';
          input.removeAttribute('aria-invalid');
          gate.hidden = true;
          prices.hidden = false;
          sync();
          prices.focus();
          input.value = '';
        } else {
          error.textContent = 'Ce code n’est pas reconnu. Vérifiez votre saisie ou demandez un accès à notre équipe.';
          input.setAttribute('aria-invalid', 'true');
          input.focus();
        }
      }, {signal: this.controller.signal});
      this.querySelector('[data-lock]').addEventListener('click', () => {
        prices.hidden = true;
        sync();
        gate.hidden = false;
        input.focus();
      }, {signal: this.controller.signal});
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
